/**
 * @todo Удалить после завершения эксперимента
 * @description Данный функционал появился в задаче CD-253017, будет удалён в задаче CD-253242
 */
export const SNR_DESKTOP_SR135_REMOVE_POPULAR = 'snr_desktop_sr135_remove_popular';
export const BX_DESKTOP_BX1106_REDESIGN_RECS_MAINPAGE = 'bx_desktop_bx1106_redesign_recs_mainpage';

/**
 * Каскадный эксперимент на микрофронтенд рекламных баннеров (ad-banner-frontend), CD-287230.
 * Учитывается только при включённом фичатогле MarTech.AdBannerMicrofrontend.Enabled:
 * группа B — баннеры рисует микрофронтенд, группа A — легаси-баннеры на библиотеках.
 */
export const MARTECH_CASCADE_EXP_FOR_ESTIMATING_MKF = 'martech_cascade_exp_for_estimating_mkf';

export const EXPERIMENTS = [
  SNR_DESKTOP_SR135_REMOVE_POPULAR,
  BX_DESKTOP_BX1106_REDESIGN_RECS_MAINPAGE,
  MARTECH_CASCADE_EXP_FOR_ESTIMATING_MKF,
];
